import React__default from 'react';
import { ProductDetailActions, ProductAnalyticsEvents } from '@grandvisionhq/fun-products';
import { isModifiedClickEvent } from '@grandvisionhq/utils';
import { VariantPicker } from './VariantPicker.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const VariantPickerContainer = (props)=>{
    const { dispatch  } = useProductDetailContext();
    const handleVariantPick = React__default.useCallback((variant, href, event)=>{
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event || !isModifiedClickEvent(event)) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            dispatch(ProductDetailActions.updateActiveVariant({
                sku: variant.sku
            }));
            window.history.replaceState(null, '', href);
        }
        ProductAnalyticsEvents.pushPdpVariantClickEvent({
            type: variant.productType,
            name: variant.name,
            id: variant.sku,
            dimension147: variant.description
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React__default.createElement(VariantPicker, {
        channelAvailability: props.channelAvailability,
        variantItems: props.variantItems,
        activeVariantSku: props.activeVariantSku,
        activeVariantLabel: props.activeVariantLabel,
        onPick: handleVariantPick,
        stockCount: props.stockCount,
        isAllowBackOrder: props.isAllowBackOrder,
        enableStockIndicator: props.enableStockIndicator
    });
};

export { VariantPickerContainer };
//# sourceMappingURL=VariantPickerContainer.js.map
